import { ITemplateSpecialPromoSchema } from '../../../repositories/developer-card/entities/template_special_promo/TemplateSpecialPromoSchema';
import type { IApplicationState } from '../../../types/redux';

import { getDeveloper } from '../getDeveloper';

export function getTemplateSpecialPromo(state: IApplicationState): ITemplateSpecialPromoSchema | null {
  return getDeveloper(state).templateSpecialPromo;
}
